import { FilteredTable } from './filtered-table';

export default FilteredTable;
